<div>
  <form [formGroup]="stepFormGroup" class="step-container">
    <mat-card class="card-general">
      <mat-card-title>Alineación</mat-card-title>
      <mat-card-content class="w-100 mt-2">
        <mat-radio-group aria-label="Seleciona una opción" formControlName="setupAlignmentType" class="d-flex flex-column gap-4" required>
          <div class="row gy-4" *ngFor="let item of setupAlignmentOptions; index as i">
            <mat-radio-button [value]="item.value"
            (change)="onChangeOption($event)"
            [checked]="item.value == getControl(stepFormGroup,'setupAlignmentType')" class="col-12 col-lg-3" ><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
            <div class="col-12 col-lg-6 pb-5" [ngClass]="{'text-border-bottom': i != 2}">
              <p class="w-fit mx-auto" style="max-width: 350px;">
                {{item.description}}
              </p>
            </div>
            <div class="col-12 col-lg-3 text-center">
              <ng-container *ngIf="i == 0">
                <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes_Mesa%20de%20trabajo%201-01.svg" />
              </ng-container>
              <ng-container *ngIf="i == 1">
                <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes_Mesa%20de%20trabajo%201-02.svg" />
              </ng-container>
              <ng-container *ngIf="i == 2">
                <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-04.svg" />
              </ng-container>
            </div>
          </div>
        </mat-radio-group>
      </mat-card-content>
    </mat-card>

    <div>
      <div class="row justify-content-start">
        <mat-checkbox formControlName="isNoMovePieces" style="width: fit-content;">No mover piezas indicadas</mat-checkbox>
      </div>
      <div class="row justify-content-center" *ngIf="getControl(stepFormGroup,'isNoMovePieces')">
        <app-pieces-container [selectedPieces]="stepFormGroup?.controls['noMovePieces'].value" style="overflow-x: auto;" [numberPieces]=7 (piecesSelected)="onSetPieces($event, stepFormGroup, 'noMovePieces')"></app-pieces-container>
      </div>
    </div>

    <mat-card class="card-general">
      <mat-card-title>Terceros Molares</mat-card-title>
      <mat-card-content class="mt-2">
        <div class="row align-items-center">
          <div class="col-12">
            <mat-radio-group aria-label="Seleciona una opción" formControlName="thirdMolarsType" class="d-flex flex-column gap-4">
              <div class="row gx-4 gy-2" *ngFor="let item of thirdMolarOptions">
                <mat-radio-button [value]="item.value" [checked]="item.value == getControl(stepFormGroup, 'thirdMolarsType')" class="col py-6"><span style="white-space:normal">{{item.display}}</span></mat-radio-button>
              </div>
            </mat-radio-group>
          </div>

          <div class="col-12" *ngIf="getControl(stepFormGroup, 'thirdMolarsType')==3">
            <app-pieces-container [axesPointValueCustom]="8" [selectedPieces]="stepFormGroup?.controls['thirdMolarDigitalExtractionPieces'].value" [numberPieces]=1 (piecesSelected)="onSetPieces($event, stepFormGroup, 'thirdMolarDigitalExtractionPieces')"></app-pieces-container>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="d-flex justify-content-center gap-4" *ngIf="isCaseDetail">
      <button mat-button matStepperPrevious class="button secondary-button"><mat-icon>chevron_left</mat-icon> Anterior</button>
      <button mat-button matStepperNext data-testid="nextStep2" class="button secondary-button" (click)="updateStepPrescription()" [disabled]="disabledButtonStages()">Guardar y Continuar <mat-icon>chevron_right</mat-icon></button>
    </div>
  </form>
</div>
